/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const MalaysiaNLIHP = lazy(() => import('./pages/MalaysiaNLIHP'))

export default [<SiteRoute key="nlihp" exact path="/" component={MalaysiaNLIHP} />]
